<template>
  <v-timeline dense>
    <v-timeline-item
      v-for="(article, i) in articles"
      :key="i"
      :color="colors[i]"
      small
      right
    >
      <!-- <template v-slot:opposite>
        <span
          :class="`headline font-weight-bold ${colors[i]}--text`"
          v-text="article.date"
        ></span>
      </template> -->
      <v-card>
        <v-card-title>{{ article.title }}</v-card-title>
        <v-card-subtitle>{{ article.date }}</v-card-subtitle>
        <v-card-text>{{ article.description }} </v-card-text>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
export default {
  props: {
    articles: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    colors: ["cyan", "green", "pink", "amber", "orange"],
    years: [
      {
        color: "cyan",
        year: "1960",
      },
      {
        color: "green",
        year: "1970",
      },
      {
        color: "pink",
        year: "1980",
      },
      {
        color: "amber",
        year: "1990",
      },
      {
        color: "orange",
        year: "2000",
      },
    ],
  }),
  computed: {
    // articles() {
    //   return this.$store.state.news.articles;
    // },
  },
};
</script>
